export enum CookieKey {
  // medtochka_medcard_token - валидируется на беке! Не менять без согласования с беком!
  MedcardToken = 'medtochka_medcard_token',
  AppSmartBannerWasClosed = 'app_smart_banner_was_closed',
  AppBannerBottomSheetWasClosed = 'app_banner_bottom_sheet_was_closed',
  AnonymousQuestionnaireUid = 'anonymous_questionnaire_uid',
  TelemedAppointmentBottomSheetWasShown = 'telemed_appointment_bottom_sheet_was_shown'
}
